<template lang="pug">
.session-details-modal.modal-wrapper.large
    .modal-header
        a.close(@click="$emit('close')")
    .modal-body
        session-details(
            :config="config"
            :session="session"
            :stop-propagation="true"
            :open-details-on-click="false"
            :condensed="true"
            :disabled="false"
        )
        .desc(v-html="description")

    .modal-footer
</template>
<script>
// Mixins
import translatable from '@/components/registration/sections/translatable.mixin.js';

export default {
    name: 'SessioonDetailsModal',

    mixins: [translatable],

    props: {
        session: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            translatable_object: this.session
        }
    },

    computed: {
        description() {
            return this.hasFpI18n(this.session) ? this.getT9Label('content') : this.getT9Label('description');
        }
    }
};
</script>
